import React from 'react'

import { NotificationInfoFragment } from '@sketch/gql-types'

import { AddShareMemberPreview } from './AddShareMemberPreview'
import { CommentMentionPreview } from './CommentMentionPreview'
import { DownloadableAssetPreview } from './DownloadableAssetPreview'
import { FolderArchivedPreview } from './FolderArchivedPreview'
import { StarPreview } from './StarPreview'
import { WorkspaceInviteAcceptedPreview } from './WorkspaceInviteAcceptedPreview'
import { WorkspaceInvitedPreview } from './WorkspaceInvitedPreview'
import { RichPreviewBox, RichPreviewText } from './InboxPreview.styles'

interface InboxPreviewBodyProps {
  notification: NotificationInfoFragment
}

export const InboxPreviewBody = ({ notification }: InboxPreviewBodyProps) => {
  if (
    notification.__typename === 'CommentNotification' ||
    notification.__typename === 'MentionNotification'
  ) {
    return <CommentMentionPreview notification={notification} />
  }

  if (notification.__typename === 'DownloadableAssetRenderedNotification') {
    return <DownloadableAssetPreview notification={notification} />
  }

  if (notification.__typename === 'AddShareMemberNotification') {
    return <AddShareMemberPreview notification={notification} />
  }

  if (notification.__typename === 'StarNotification') {
    return <StarPreview notification={notification} />
  }

  if (notification.__typename === 'FolderArchivedNotification') {
    return <FolderArchivedPreview notification={notification} />
  }

  if (notification.__typename === 'WorkspaceInvitedNotification') {
    return <WorkspaceInvitedPreview notification={notification} />
  }

  if (notification.__typename === 'WorkspaceInviteAcceptedNotification') {
    return <WorkspaceInviteAcceptedPreview notification={notification} />
  }

  return (
    <RichPreviewBox>
      <RichPreviewText>Rich Summary / Preview</RichPreviewText>
    </RichPreviewBox>
  )
}
